import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=26dc5f63&scoped=true&"
import script from "./CustomFields.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomFields.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dc5f63",
  null
  
)

export default component.exports